import AppModal from 'components/common/modal/AppModal';
import PlainModal from 'components/common/modal/PlainModal';
import ProjectReworkModal from 'components/project/ProjectReworkModal';
import React, { useEffect, useMemo, useState } from 'react';
import { IProjectInfo, IRemake } from 'lib/types/projectTypes';
import { useTranslation } from 'react-i18next';
import useInput from 'lib/hooks/useInput';
import ProjectDetail from 'components/project/ProjectDetail';
import { ProjectActions } from 'store/actionCreators';
import {
  ceramicMetalIconList,
  occlusalSurfaceIconList,
  restorationPonticIconList,
} from 'lib/teeth/teethDesignMapper';

interface ProjectDetailContainerProps {
  indicationFormat: object | any;
  indicationInfo: object | any;
  language: string;
  hasAlarm: any;
  projectInfo: IProjectInfo;
  isProjectCreator: boolean;
  managerList: object | any;
  remakeList: IRemake[];
  prevPartnerManager: number | null;
  partnerManager: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  onChangePartnerManager: (number: number) => void;
}

function ProjectDetailContainer({
  indicationFormat,
  indicationInfo,
  language,
  hasAlarm,
  projectInfo,
  isProjectCreator,
  managerList,
  remakeList,
  prevPartnerManager,
  partnerManager,
  onChangePartnerManager,
}: ProjectDetailContainerProps) {
  const { projectCode, ownerReworkType, partnerReworkType } = projectInfo;
  const { restorationPonticDesign, occlusalSurfaceDesign, ceramicMetalDesign } =
    projectInfo.indication;

  const { t } = useTranslation();
  const [reworkStatusModalOpen, setReworkStatusModalOpen] = useState(false);

  const handleCloseReworkStatusModal = () => setReworkStatusModalOpen(false);
  const handleOpenReworkStatusModal = () => setReworkStatusModalOpen(true);

  const reworkList = isProjectCreator ? ownerReworkType : partnerReworkType;
  const reworkListCt = useInput([]);

  useEffect(() => {
    reworkListCt.setValue(reworkList);
  }, [reworkList]);

  const handleEditRework = (data: number[]) => {
    ProjectActions.edit_project_rework_request({ projectCode, data: { reworkType: data } });
  };

  const selectedRestorationPontic = restorationPonticIconList.find(
    item => item.id === restorationPonticDesign,
  );
  const selectedceramicMatel = ceramicMetalIconList.find(item => item.id === ceramicMetalDesign);
  const selectedOcclusalSurface = occlusalSurfaceIconList.find(
    item => item.id === occlusalSurfaceDesign,
  );

  const extraDesignOp = {
    selectedRestorationPontic,
    selectedceramicMatel,
    selectedOcclusalSurface,
  };

  return (
    <>
      {useMemo(
        () => (
          <PlainModal
            isOpen={reworkStatusModalOpen}
            onClose={handleCloseReworkStatusModal}
            width={570}
          >
            <AppModal
              title={t('REWORK_PROGRESS')}
              headerCenterText={''}
              headerCenterTextStyle={{ width: 325 }}
              content={
                <ProjectReworkModal
                  reworkListCt={reworkListCt}
                  onEditRework={handleEditRework}
                  onClose={handleCloseReworkStatusModal}
                />
              }
              contentCardStyle={{
                padding: '0',
                borderRadius: '8px',
              }}
              isCloseIcon={true}
              onCancel={handleCloseReworkStatusModal}
              hideButton={true}
            />
          </PlainModal>
        ),
        [reworkStatusModalOpen],
      )}
      <ProjectDetail
        extraDesignOp={extraDesignOp}
        reworkListCt={reworkListCt}
        indicationFormat={indicationFormat}
        indicationInfo={indicationInfo}
        language={language}
        hasAlarm={hasAlarm}
        projectInfo={projectInfo}
        isProjectCreator={isProjectCreator}
        managerList={managerList}
        remakeList={remakeList}
        prevPartnerManager={prevPartnerManager}
        partnerManager={partnerManager}
        onChangePartnerManager={onChangePartnerManager}
        onOpenReworkStatusModal={handleOpenReworkStatusModal}
      />
    </>
  );
}

export default React.memo(ProjectDetailContainer);
